import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalManagerContext } from '../../ModalsManager';
import PlotWrapper from '../../common/PlotWrapper';

import FilteredBarChart from '../../common/charts/FilteredBarChart';

import useFetch from '../../../utils/useFetch';
import useStyles from './styles';
import { parseCategories, parseLikes } from './utils';


const url = `${process.env.REACT_APP_API_URL}/analytics/interests`;

const Interests = () => {
  const { t } = useTranslation(['translation']);
  const openModal = useContext(ModalManagerContext);
  const { data, render } = useFetch(url, openModal);
  const [plotData, setPlotData] = useState(null);

  if (data && !plotData) {
    const categoriesData = parseCategories(data);
    const likesData = parseLikes(data);
    setPlotData({
      categoriesData,
      likesData,
      chosenCategory: categoriesData[categoriesData.length - 1].name,
    });
  }

  const classes = useStyles();
  return render(() => {
    const onChartClick = newData => {
      setPlotData(oldData => ({
        ...oldData,
        chosenCategory: newData.data.name,
      }));
    };

    const { chosenCategory, categoriesData, likesData } = plotData;
    return (
      <div className={classes.container}>
        <PlotWrapper
          title={t('ANALYTICS.TOP_CATEGORIES', { count: 10 })}
          overriddenClasses={classes}
          showTooltip
          tooltipText={t('ANALYTICS.TOP_CATEGORIES_TOOLTIP')}
        >
          <FilteredBarChart
            data={categoriesData}
            legendTitle={t('ANALYTICS.TOP_CATEGORIES_LEGEND')}
            unitName="likes"
            selected={chosenCategory}
            onEvents={{ click: onChartClick }}
          />
        </PlotWrapper>
        <PlotWrapper
          title={t('ANALYTICS.TOP_LIKES', { count: 20 })}
          overriddenClasses={classes}
        >
          <FilteredBarChart
            data={likesData[chosenCategory]}
            legendTitle="Likes"
            unitName="likes"
          />
        </PlotWrapper>
      </div>
    );
  });
};


export default Interests;
